// extracted by mini-css-extract-plugin
module.exports = {"modal":"PatientDocumentInfo_modal__2Y0RQ"};